import { TriangleAlert } from "lucide-react";

import style from "./PCRSNotOnPanelNotice.module.css";

// PCRS explicitly reports the patient is not on this GP's panel (the web-service
// response carried a "Patient not on GP Panel" error). Distinct from the
// mid-month panel-transfer warning: this is not a timing issue that clears on
// the 1st — the patient simply is not on the panel, so a review would be
// rejected. Surfaced as its own error notice.
export const PCRSNotOnPanelNotice = () => {
  return (
    <div className={style.notice} role="alert">
      <TriangleAlert size={20} className={style.icon} />
      <p className={style.text}>
        This patient is not on your panel. PCRS has them registered with a
        different GP, so CDM reviews cannot be started or submitted for them
        (they would be rejected — &ldquo;Patient not on GP Panel&rdquo;). Confirm
        the patient is on your panel in PCRS first.
      </p>
    </div>
  );
};
